import { takeEvery, select, fork } from 'redux-saga/effects';

import { trackCustomHeapEvent } from '@tcc/analytics';
import { TRACK_EVENT, TRACK_HEAP_EVENT } from '../constants/actionTypes';
import { getIdsFromHash } from '../utils/url';
import { processLayerValues, trackEvent, getLayer } from '../utils/analytics';

export function* trackAnalyticsEvent(action) {
  const { field, layers, crops, user } = yield select();

  const hashValues = getIdsFromHash();
  const layerValues = processLayerValues(hashValues);

  const crop1 = layerValues.crop[0] && crops[layerValues.crop[0]];
  const crop2 = layerValues.crop[1] && crops[layerValues.crop[1]];

  const [layer1, layer2] = getLayer({ hashValues, layerValues, layers });
  trackEvent(action.noun, action.verb, {
    classification: 'mapbook',
    cropUuid1: crop1 ? crop1.uuid : null,
    cropUuid2: crop2 ? crop2.uuid : null,
    fieldId: field.uuid,
    layer1,
    layer2,
    namespace: 'fieldview.mapbook',
    proxy: user.isProxying,
    previewUserId: user.id,
    seasonTag1: layerValues.season[0],
    seasonTag2: layerValues.season[1] || null,
    source: 'web',
    taxonomyVersion: 'v1',
    year1: layerValues.year[0],
    year2: layerValues.year[1] || null,
    uiLocation: layers.isSplitViewEnabled ? 'split_view' : 'field_map',
    ...action.params,
  });
}

export function* trackHeapEvent(action) {
  const { user } = yield select()

  const heapDetails = {
    app: 'digital-mapbook-web',
    subscriptionTier: user.subscription,
    countryCode: user.countryCode,
    isProxying: user.isProxying,
    version: process.env.npm_package_version,
    ...action.additionalDetails
  }

  trackCustomHeapEvent(action.event, heapDetails);
} 

export function* trackAnalyticsEventWatcher() {
  yield takeEvery(TRACK_EVENT, trackAnalyticsEvent);
  yield takeEvery(TRACK_HEAP_EVENT, trackHeapEvent);
}

export default function* rootSaga() {
  yield fork(trackAnalyticsEventWatcher);
}
